module.exports = __webpack_public_path__ + "static/media/message-view-icon.772d75ad.svg";